import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

// Pusher.logToConsole = true;

// Broadcast::routes() registers /broadcasting/auth at the app root, not under /api
const AUTH_ENDPOINT = `${(window.APP_CONFIG?.serverIp || process.env.VUE_APP_SERVER_IP || "").replace(/\/api\/?$/, "")}/broadcasting/auth`;
// const AUTH_ENDPOINT = "http://10.110.10.129:8002/broadcasting/auth";

export const echo = new Echo({
  broadcaster: "pusher",
  key: "d0bee0e9e02bb4307b0e",
  cluster: "ap2",
  forceTLS: true,
  authEndpoint: AUTH_ENDPOINT,
  // Reads the token fresh on every channel subscription instead of once at
  // module load, so a login that happens after this file first runs is
  // always picked up. Accept: application/json keeps a failed auth as a
  // clean 401 instead of a redirect that surfaces as a 405.
  authorizer: (channel) => ({
    authorize: (socketId, callback) => {
      fetch(AUTH_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: new URLSearchParams({
          socket_id: socketId,
          // Read fresh on every auth so a login after module load is picked up.
          channel_name: channel.name,
        }),
      })
        .then(async (response) => {
          if (!response.ok) {
            console.log('res', response, channel)
            callback(true, await response.text());
            return;
          }
          callback(false, await response.json());
        })
        .catch((error) => callback(true, error));
    },
  }),
});
